<atx-skeleton-basic
  class="tile-hight tile-width tile-padding"
  [style.height]="'tile-hight'"
  [style.width]="'tile-width'"
></atx-skeleton-basic>
